import { fetch } from '@atlassian/eoc-fetch';

import type {
	RoleBasedNotificationDetailResponse,
	RoleBasedNotificationsResponse,
} from '../../common/types';

export const getRoleBasedNotificationsEndpoint = (): Promise<RoleBasedNotificationsResponse> =>
	fetch<RoleBasedNotificationsResponse>(`/v1/role-based-notifications`);

export const getRoleBasedNotificationDetailEndpoint = (
	settingId: string,
): Promise<RoleBasedNotificationDetailResponse> =>
	fetch<RoleBasedNotificationDetailResponse>(`/v1/role-based-notifications/${settingId}`);
